import React, { useContext, useEffect, useState } from 'react'
import * as S from './CarecoAdminStyle'
import Overview from '../Overview'
import AdoptionSnapshot from '../AdoptionSnapshot'
import TopQueries from '../TopQueries'
import PendingActiion from '../PendingActiion'
import { DateControlContext } from 'contexts/DateControlContext'
import { getDashboardDateApiParams } from '../../helpers/dashboardDateParams'
import { loadCarcoAdminDashboard } from '../../api/dashboard'
// import AskAIChatbot from '../AskAIChatbot' // hidden in UI for now
import LoaderScreen from 'uiKit/loaders/loaderScreen'

const CarecoAdminDashboard: React.FC<{ botId: string }> = ({ botId }) => {
  const {
    dateRange: { startDate, endDate },
    frequency,
  } = useContext(DateControlContext)
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    const dateParams = getDashboardDateApiParams(frequency, startDate, endDate, true)
    loadCarcoAdminDashboard(botId, dateParams)
      .then(res => setData(res))
      .finally(() => setLoading(false))
  }, [botId, startDate, endDate, frequency])
  if (loading)
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <LoaderScreen />
      </div>
    )
  return (
    <S.Section>
      <S.LeftColumn>
        <Overview data={data?.overview || null} />
        <AdoptionSnapshot datas={data || null} />
        <S.FlexBlock style={{ gap: 16, alignItems: 'stretch' }}>
          <div style={{ flex: '1 1 50%', width: '50%', display: 'flex' }}>
            <TopQueries data={data?.topQueriedTopics?.slice(0, 5) || null} />
          </div>
          <div style={{ flex: '1 1 50%', width: '50%', display: 'flex' }}>
            <PendingActiion data={data?.pendingActions || null} />
          </div>
        </S.FlexBlock>
      </S.LeftColumn>
      {/* Right column (AskAIChatbot) hidden in UI for now */}
      {/* <S.RightColumn>
        <AskAIChatbot data={{ dateRange: { startDate, endDate }, ...data }} botId={botId} />
      </S.RightColumn> */}
    </S.Section>
  )
}

export default CarecoAdminDashboard
